import { createSelector } from "@reduxjs/toolkit";
import { slideNodesAdapter } from "@store/slide-nodes/slide-nodes-slice";
/**
 * Get the store slide nodes
 */
export const slideNodesSelector = createSelector(state => state.slideNodes, slideNodes => {
  return slideNodesAdapter.getSelectors().selectAll(slideNodes);
});